module.exports = __webpack_public_path__ + "static/media/oneHeart.4f03284d.png";